module.exports = "/_next/static/images/volt-ffc0cab5b0e548323b8317eb7aaf68eb.svg";